/**
 * Invoice-level discount section.
 * Extracted from InvoiceManager.
 */

import styles from './invoiceManagerStyles';

export interface InvoiceDiscountSectionProps {
  discountType: string;
  onSetDiscountType: (v: string) => void;
  discountValue: string;
  onSetDiscountValue: (v: string) => void;
  currencyCode: string;
  onPreviewChanges: () => void;
}

export default function InvoiceDiscountSection({
  discountType, onSetDiscountType, discountValue, onSetDiscountValue,
  currencyCode, onPreviewChanges,
}: InvoiceDiscountSectionProps) {
  return (
    <div style={styles.card}>
      <h2 style={styles.cardTitle}>Invoice-Level Discount</h2>
      <div className="flex flex-wrap gap-md">
        <select
          value={discountType}
          onChange={(e) => onSetDiscountType(e.target.value)}
          style={styles.select}
        >
          <option value="none">No Discount</option>
          <option value="percentage">Percentage (%)</option>
          <option value="amount">Fixed Amount ({currencyCode})</option>
        </select>
        <input
          type="number"
          value={discountValue}
          onChange={(e) => onSetDiscountValue(e.target.value)}
          placeholder="Enter discount value"
          style={{ ...styles.input, flex: 1 }}
          step="0.01"
          disabled={discountType === 'none'}
        />
        <button onClick={onPreviewChanges} style={styles.primaryBtn}>
          Preview Changes
        </button>
      </div>
      <p className="mt-sm text-sm" style={{ color: 'var(--color-text-light)' }}>
        Modify line items above or add an invoice-level discount, then click &quot;Preview Changes&quot;
      </p>
    </div>
  );
}
